import { Button, Toast } from '@fattureincloud/fic-design-system'
import React, { FC, useEffect, useState } from 'react'

import { httpRequest } from '../../common/network'
import { ArticleLoading } from '../Articles/article.components'
import { HelpModal, Table, TableData, TableRow } from '../common.components'
import { ArticleInfo } from '../definitions'
interface Props {
    isOpen: boolean
    onClose: () => void
    changeView: (searchKey: string, page: string) => void
    type: string
    id: number
}
import { errorMessage, locale } from '../../locales/locale'

const UsageModal: FC<Props> = (props: Props) => {
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<ArticleInfo[]>()
    const getData = () => {
        setLoading(true)
        httpRequest({
            method: 'GET',
            path: `help/usage`,
            params: {
                type: props.type,
                id: props.id,
            },
            onSuccess(res: { data: ArticleInfo[] }) {
                if (!(res.data && res.data.length > 0)) {
                    Toast.warning(locale('Nessun utilizzo trovato'))
                    props.onClose()
                }
                setData(res.data)
                setLoading(false)
            },
            onError: (res: { message: string }) => {
                Toast.error(errorMessage, { content: res?.message })
                props.onClose()
            },
        })
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <HelpModal
            title={data?.length == 1 ? locale('Utilizzo') : locale('Utilizzato in ') + String(data?.length) + locale(' articoli')}
            isOpen={!loading && data?.length > 0}
            onActionClose={() => props.onClose()}
            footer={() => (
                <>
                    <Button
                        text={locale('Chiudi')}
                        color={'grey'}
                        onClick={() => {
                            props.onClose()
                        }}
                    />
                </>
            )}
        >
            <>
                {loading && <ArticleLoading
                    className={'articleContainer'}
                    isExternal={true}
                />}
                {!loading && data?.length > 0 && (
                    <>
                        <Table id={'usages'}>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>{locale('Realm')}</th>
                                    <th>{locale('Titolo')}</th>
                                    <th>{locale('Link')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((c) => {
                                    return (
                                        <TableRow key={String(c.id)}>
                                            <TableData>{c.id}</TableData>
                                            <TableData>{c.realm}</TableData>
                                            <TableData wrap={true}>{c.title}</TableData>
                                            <TableData>
                                                <Button
                                                    text={locale('Apri')}
                                                    onClick={() => props.changeView(c.permalink, 'articolo')}
                                                />
                                            </TableData>
                                        </TableRow>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </>
                )}
            </>
        </HelpModal>
    )
}

export default UsageModal